const cards = [
  {
    title: '重生之都市修仙',
    author: '十里剑神',
    tag: '国漫·热血',
    rating: '9.5',
    hot: '128话连载中',
    desc: '一代仙尊重生都市，修法术、战强敌，这一世他要弥补所有遗憾，守护挚爱之人。',
    img: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20urban%20cultivation%20fantasy%2C%20male%20protagonist%20with%20flowing%20energy%2C%20modern%20city%20backdrop%2C%20warm%20golden%20and%20coral%20tones%2C%20dynamic%20composition%2C%20chinese%20manhua%20style%2C%20clean%20background&width=600&height=800&seq=card-01&orientation=portrait',
  },
  {
    title: '社长大人是恶魔',
    author: '朴海娜',
    tag: '韩漫·恋爱',
    rating: '9.3',
    hot: '56话连载中',
    desc: '冷酷社长与新人职员的办公室恋情，表面冷漠内心温柔的他，让人心跳加速。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20style%20illustration%20of%20office%20romance%2C%20elegant%20couple%20in%20modern%20setting%2C%20warm%20pink%20and%20cream%20tones%2C%20soft%20romantic%20atmosphere%2C%20clean%20composition%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=card-02&orientation=portrait',
  },
  {
    title: '咒术狂潮',
    author: '佐藤健一',
    tag: '日漫·奇幻',
    rating: '9.7',
    hot: '203话连载中',
    desc: '咒术师与诅咒之王的宿命对决，炫酷战斗场面与深刻角色塑造，年度必看神作。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20style%20illustration%20of%20supernatural%20battle%2C%20dynamic%20action%20pose%20with%20energy%20effects%2C%20warm%20amber%20and%20dark%20tones%2C%20shonen%20manga%20aesthetic%2C%20clean%20composition&width=600&height=800&seq=card-03&orientation=portrait',
  },
  {
    title: '穿越异世界成为药王',
    author: '药炉居士',
    tag: '国漫·奇幻',
    rating: '9.1',
    hot: '89话连载中',
    desc: '现代药剂师穿越异世界，凭借专业知识成为大陆最强药王，治病救人扬名天下。',
    img: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20fantasy%20alchemist%20with%20herbs%20and%20potions%2C%20warm%20green%20and%20cream%20tones%2C%20magical%20atmosphere%2C%20clean%20composition%2C%20isekai%20theme%2C%20soft%20lighting&width=600&height=800&seq=card-04&orientation=portrait',
  },
  {
    title: '武林至尊',
    author: '江南烟雨',
    tag: '国漫·武侠',
    rating: '9.4',
    hot: '301话连载中',
    desc: '少年从无名小卒成长为武林至尊，热血江湖中的恩怨情仇，侠义与武学并存。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manga%20cover%20style%2C%20swordsman%20in%20ancient%20robes%20with%20flowing%20movement%2C%20warm%20golden%20and%20coral%20tones%2C%20wuxia%20atmosphere%2C%20elegant%20composition&width=600&height=800&seq=card-05&orientation=portrait',
  },
  {
    title: '甜蜜陷阱',
    author: '花间一壶酒',
    tag: '恋爱·校园',
    rating: '9.2',
    hot: '33话连载中',
    desc: '青梅竹马多年后重逢，从误会到心动，甜蜜又虐心的校园恋爱故事，画风超赞。',
    img: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20sweet%20school%20romance%2C%20two%20characters%20under%20cherry%20blossoms%2C%20warm%20pink%20and%20cream%20tones%2C%20soft%20romantic%20atmosphere%2C%20shoujo%20style%2C%20clean%20composition&width=600&height=800&seq=card-06&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门漫画推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            精选高分漫画作品，韩漫日漫国漫一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {cards.map((card) => (
            <a
              key={card.title}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-[280px] md:h-[320px] overflow-hidden">
                <img
                  src={card.img}
                  alt={`${card.title} ${card.tag} 漫画推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 px-2.5 py-1 bg-black/60 text-accent-400 text-xs font-semibold rounded-full">
                  <i className="ri-star-fill text-xs"></i>
                  {card.rating}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between mb-1.5">
                  <h3 className="text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <span className="text-xs text-primary-600 font-medium whitespace-nowrap ml-2">{card.hot}</span>
                </div>
                <p className="text-xs text-foreground-400 mb-2">{card.author}</p>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}